import { Svg, SvgPath } from 'primitives/Svg'
import { SvgIconProps } from '.'

export const AsteriskGradient: React.FC<SvgIconProps> = ({ css }) => (
  <Svg
    width='26'
    height='26'
    viewBox='0 0 46 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    css={css}
  >
    <mask
      id='mask0_1198_6724'
      maskUnits='userSpaceOnUse'
      x='1'
      y='0'
      width='44'
      height='40'
    >
      <path
        d='M11.0721 23.025L1.47585 20.501C1.39064 20.4779 1.31117 20.4385 1.24235 20.3851C1.17352 20.3317 1.11675 20.2654 1.07545 20.1903C1.03415 20.1152 1.0092 20.0328 1.00211 19.9481C0.995015 19.8635 1.00585 19.7784 1.03412 19.6979L5.25732 7.89859C5.28608 7.81979 5.3309 7.74732 5.38928 7.68539C5.44767 7.62346 5.51843 7.57337 5.59729 7.53802C5.67615 7.50267 5.76155 7.48276 5.84853 7.47952C5.93551 7.47628 6.02223 7.48968 6.10371 7.51906L15.2032 10.8992C15.3057 10.9434 15.4184 10.9615 15.5304 10.9518C15.6423 10.942 15.7498 10.9047 15.8423 10.8435C15.9348 10.7823 16.0092 10.6992 16.0585 10.6023C16.1077 10.5054 16.13 10.3978 16.1233 10.2902L15.6632 0.653135C15.6582 0.56834 15.6714 0.483417 15.7021 0.403741C15.7328 0.324064 15.7802 0.251292 15.8415 0.190005C15.9028 0.128719 15.9766 0.0802766 16.0584 0.0475871C16.1401 0.0148976 16.228 -0.00127437 16.3166 7.83723e-05H29.4919C29.5789 1.74123e-06 29.665 0.0167305 29.7449 0.0494185C29.8249 0.0821064 29.8972 0.130022 29.9573 0.190221C30.0175 0.25042 30.0644 0.321721 30.0951 0.399755C30.1258 0.477788 30.1396 0.560975 30.1359 0.644301L29.7955 10.299C29.7888 10.4066 29.8112 10.5141 29.8604 10.611C29.9096 10.7079 29.9841 10.7911 30.0766 10.8523C30.1691 10.9135 30.2766 10.9508 30.3885 10.9606C30.5004 10.9703 30.6131 10.9522 30.7156 10.908L39.8243 7.51906C39.907 7.48975 39.995 7.47667 40.083 7.48038C40.1711 7.4841 40.2575 7.50455 40.3372 7.54071C40.4169 7.57688 40.4883 7.62804 40.5471 7.691C40.606 7.75396 40.6512 7.82751 40.68 7.90742L44.7743 19.6979C44.8025 19.7784 44.8135 19.8635 44.8064 19.9481C44.7993 20.0328 44.7743 20.1152 44.733 20.1903C44.6917 20.2654 44.635 20.3317 44.5661 20.3851C44.4973 20.4385 44.4178 20.4779 44.3326 20.501L34.7363 23.025C34.6337 23.0521 34.5396 23.1028 34.4621 23.1727C34.3846 23.2426 34.3261 23.3296 34.2916 23.4262C34.2572 23.5227 34.2478 23.6258 34.2643 23.7266C34.2809 23.8274 34.3229 23.9229 34.3866 24.0046L40.4592 31.5854C40.5116 31.6513 40.5498 31.7265 40.5717 31.8067C40.5936 31.8868 40.5987 31.9704 40.5868 32.0525C40.5748 32.1346 40.546 32.2136 40.502 32.2849C40.4579 32.3562 40.3996 32.4184 40.3303 32.4679L29.8231 39.8811C29.679 39.9767 29.5014 40.0137 29.3289 39.9839C29.1565 39.9541 29.0033 39.8601 28.9031 39.7223L23.4379 31.7796C23.3786 31.6922 23.2974 31.6204 23.2018 31.5706C23.1062 31.5209 22.9991 31.4949 22.8904 31.4949C22.7816 31.4949 22.6746 31.5209 22.579 31.5706C22.4834 31.6204 22.4023 31.6922 22.343 31.7796L16.9974 39.7223C16.8985 39.8615 16.7461 39.9574 16.5735 39.9888C16.401 40.0203 16.2225 39.9847 16.0773 39.8899L5.57932 32.4768C5.50901 32.428 5.44965 32.3661 5.4049 32.2948C5.36014 32.2235 5.33089 32.1443 5.31886 32.0619C5.30683 31.9795 5.31231 31.8955 5.33493 31.8152C5.35754 31.7348 5.39685 31.6596 5.45049 31.5942L11.5137 24.0134C11.5828 23.9264 11.6266 23.8234 11.6406 23.7149C11.6546 23.6064 11.6384 23.4962 11.5935 23.3957C11.5486 23.2952 11.4766 23.2079 11.385 23.1427C11.2934 23.0776 11.1854 23.037 11.0721 23.025Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0_1198_6724)'>
      <g filter='url(#filter0_f_1198_6724)'>
        <SvgPath
          d='M-18.2285 -17.8717H64.0953V64.4521H-18.2285V-17.8717Z'
          fill='#C4C4C4'
        />
        <SvgPath
          d='M54.1924 17.3308C56.9617 26.585 51.7046 36.332 42.4504 39.1013C33.1962 41.8706 23.4492 36.6135 20.6799 27.3593C17.9106 18.1051 23.1677 8.35815 32.4219 5.58885C41.6761 2.81955 51.423 8.0766 54.1924 17.3308Z'
          fill='#F3E289'
        />
        <SvgPath
          d='M34.3687 3.19051C36.6082 10.6743 32.3568 18.5566 24.8731 20.7961C17.3893 23.0356 9.50702 18.7843 7.26752 11.3005C5.02801 3.81671 9.27933 -4.06557 16.7631 -6.30507C24.2469 -8.54458 32.1292 -4.29326 34.3687 3.19051Z'
          fill='#9CA0CC'
        />
        <SvgPath
          d='M47.7218 -3.6693C49.9613 3.81447 45.7099 11.6967 38.2262 13.9363C30.7424 16.1758 22.8601 11.9244 20.6206 4.44067C18.3811 -3.04311 22.6324 -10.9254 30.1162 -13.1649C37.6 -15.4044 45.4823 -11.1531 47.7218 -3.6693Z'
          fill='#F8CB2A'
        />
        <SvgPath
          d='M24.8204 4.78363C27.4015 13.4086 22.5018 22.4929 13.8768 25.0739C5.25181 27.655 -3.83247 22.7553 -6.41348 14.1303C-8.9945 5.50532 -4.09488 -3.57896 4.53013 -6.15998C13.1551 -8.741 22.2394 -3.84138 24.8204 4.78363Z'
          fill='#5F59DF'
        />
        <SvgPath
          d='M35.0169 31.9706C37.1877 39.2247 33.0668 46.865 25.8128 49.0358C18.5587 51.2066 10.9183 47.0857 8.74758 39.8317C6.57681 32.5776 10.6976 24.9372 17.9517 22.7665C25.2058 20.5957 32.8461 24.7165 35.0169 31.9706Z'
          fill='#CB5FC7'
        />
        <SvgPath
          d='M18.9077 30.1868C21.1645 37.7283 16.8804 45.6713 9.33891 47.9281C1.79741 50.1849 -6.14566 45.9008 -8.40244 38.3593C-10.6592 30.8178 -6.37511 22.8747 1.16639 20.6179C8.70789 18.3612 16.651 22.6453 18.9077 30.1868Z'
          fill='#764ECC'
        />
      </g>
    </g>
    <defs>
      <filter
        id='filter0_f_1198_6724'
        x='-24.6051'
        y='-24.2483'
        width='95.0769'
        height='95.077'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='BackgroundImageFix'
          result='shape'
        />
        <feGaussianBlur
          stdDeviation='3.1883'
          result='effect1_foregroundBlur_1198_6724'
        />
      </filter>
    </defs>
  </Svg>
)
